import {connect} from 'react-redux';

import {
    setIngestReportAction,
    resetIngestReportAction,
    IngestReportContainer,
} from '@pluto/ingest-validation-report';

import {IngestReport} from '@pluto/ingest-validation-report/IngestReportTypes';

export type IngestReportState = {ingestReport: IngestReport};

export type State = {
    qcTools: {
        ingestReport: IngestReport | null,
    }
}

export const mapState = (state: State) => {
    const {qcTools} = state;
    const {ingestReport} = qcTools;
    
    return {
        ingestReport,
    };
};

const mapDispatch = {
    setReport: setIngestReportAction,
    resetReport: resetIngestReportAction,
};

export default connect(mapState, mapDispatch)(IngestReportContainer);
